import React from "react";
import { default as Dial } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const Dialog = ({
  theme,
  openDialog,
  secondaryOnClick,
  primaryOnClick,
  tertiaryOnClick,
  errorMessage,
  titleIcon,
  title,
  primaryAction,
  secondaryAction,
  tertiaryAction,
  customContent,
  primaryDisabled,
}) => {
  const safeTheme = theme ?? createTheme(); // ✅ fix crash
  const [loading, setLoading] = React.useState(false);
  const clickedRef = React.useRef(false);
  React.useEffect(() => {
    if (openDialog) {
      clickedRef.current = false;
      setLoading(false);
    }
  }, [openDialog]);

  return (
    <ThemeProvider theme={safeTheme}>
      <Dial
        //theme={theme}
        open={openDialog}
        onClose={secondaryOnClick}
        aria-labelledby="custom-dialog-title"
        sx={{
          "& .MuiPaper-root": {
            background: theme?.palette.background.alt,
          },
        }}
        PaperProps={{
          style: {
            minWidth: "350px",
            padding: "1rem",
            maxHeight: "80vh",
            overflowY: "auto",
          },
        }}
      >
        <DialogTitle
          id="custom-dialog-title"
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          {titleIcon}
          {title}
        </DialogTitle>

        <DialogContent>
          {customContent ? (
            customContent
          ) : errorMessage ? (
            <DialogContentText>{errorMessage}</DialogContentText>
          ) : (
            <DialogContentText>No content provided.</DialogContentText>
          )}
        </DialogContent>
        
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            px: 3,
            pb: 2,
          }}
        >
          {/* Left side — tertiary */}
          <Box>
            {tertiaryAction && (
              <Button onClick={tertiaryOnClick}>{tertiaryAction}</Button>
            )}
          </Box>

          {/* Right side — secondary + primary */}
          <Box>
            {secondaryAction && (
              <Button onClick={secondaryOnClick} sx={{ mr: 1 }}>
                {secondaryAction}
              </Button>
            )}
            {primaryAction && (
              <Button
                variant="contained"
                sx={{ fontWeight: "bold", minWidth: 48, minHeight: 36 }}
                disabled={primaryDisabled || loading}
                onClick={(e) => {
                  if (clickedRef.current || loading) return;
                  clickedRef.current = true;
                  setLoading(true);
                  primaryOnClick(e);
                }}
              >
                {loading ? <CircularProgress size={24} color="inherit" /> : primaryAction}
              </Button>
            )}
          </Box>
        </DialogActions>
      </Dial>
    </ThemeProvider>
  );
};

export default Dialog;
